import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import React from "react";
import { WEEKDAYS_SHORT } from "../../util/constants";
import PageLoading from "../PageLoading";

const ScheduleEditorCalendar = (props) => {
  return (
    <>
      {props.isLoading ? (
        <Box sx={{ marginLeft: "48%" }}>
          <PageLoading />
        </Box>
      ) : (
        <Grid container sx={{ fontWeight: "bold" }} data-testid="stars-calendar">
          {WEEKDAYS_SHORT.map((day, index) => (
            <Grid item md={12 / WEEKDAYS_SHORT.length} key={index}>
              <Box
                sx={{
                  padding: "1px",
                  border: "solid 0.5px",
                  borderTop: "none",
                  borderColor: "secondary.swaGray3",
                  backgroundColor: "secondary.swaGray2",
                }}
              >
                {day}
              </Box>
            </Grid>
          ))}
          {props.dayState.map((dayState, index) => (
            <Grid item md={12 / WEEKDAYS_SHORT.length} key={index}>
              <Box
                sx={{
                  border: "solid 0.5px",
                  minHeight: "15.2vh",
                  borderColor: "secondary.swaGray2",
                  backgroundColor: dayState.additionalDate ? "secondary.swaGray1" : "",
                }}
                onClick={() => props.handleDialogOpen(dayState)}
              >
                {
                  <props.DayComponent
                    dayState={dayState}
                    station={props.station}
                    handleDialogOpen={props.handleDialogOpen}
                  />
                }
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

ScheduleEditorCalendar.propTypes = {
  dayState: PropTypes.array.isRequired,
  station: PropTypes.string.isRequired,
  DayComponent: PropTypes.func.isRequired,
  handleDialogOpen: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default ScheduleEditorCalendar;
